import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useGlobalLoading } from '../../../../hooks/loadingHooks';
import { useAppSelector } from '../../../../reducers';
import { packagedQuantityBySkuIdSelector } from '../../../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../../../utils/urls/appQueryParamUtilsLegacy';
import { MerchCardLayoutUI } from '../../../../v2/components/MerchCardLayoutUI';
import { IncludedHubSpotCredits } from '../../../../v2/components/merch-card/credits-display/IncludedHubSpotCredits';
import { SUITE_CARD } from '../../../../v2/constants/tracking/TrackingSources';
import DetailedTermSelector from '../../../common/TermSelectors/DetailedTermSelector';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import { SuiteFeatures } from '../../features-display/SuiteFeatures';
import { PriceDisplayContainer } from '../../price-display/PriceDisplayContainer';
import { useCrmSuiteBundleApiName, useCrmSuiteBundleSkuId } from '../../price-display/useCrmSuite';
import { IncludedSeatsDisplayContainerV1 } from '../../seats-display/IncludedSeatsDisplayContainerV1';
import { SuiteCardCTAs } from './SuiteCardCTAs';
import { SuiteCardSubheading } from './SuiteCardSubheading';
import { SuiteCardTitle } from './SuiteCardTitle';
import { jsx as _jsx } from "react/jsx-runtime";
const TRACKING_SOURCE = SUITE_CARD;

// This is used as the merch card for the customer platform routes
export const StandardSuiteCard = ({
  productLevel,
  screen,
  columnStart,
  Badge
}) => {
  const isAppReady = useGlobalLoading();
  const isMobile = useIsMobile();
  const suiteSkuId = useCrmSuiteBundleSkuId({
    productLevel
  });
  const suiteApiName = useCrmSuiteBundleApiName({
    productLevel
  });
  const {
    queryParamTerm,
    setQueryParamTerm
  } = useQueryParamTerm();
  const includedProductLevelHubspotCredits = useAppSelector(state => {
    if (!suiteSkuId) return null;
    return packagedQuantityBySkuIdSelector(state, {
      skuId: suiteSkuId,
      unitName: 'HUBSPOT_CREDITS'
    });
  });
  const trackingSourceString = `${TRACKING_SOURCE}-${productLevel.toLowerCase()}`;
  const SubHeading = /*#__PURE__*/_jsx(SuiteCardSubheading, {
    productLevel: productLevel
  });
  const Seats = /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [20],
    widths: [140],
    children: suiteSkuId ? /*#__PURE__*/_jsx(IncludedSeatsDisplayContainerV1, {
      skuId: suiteSkuId
    }) : null
  });
  const TermSelector = /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [41],
    widths: ['100%'],
    children: suiteApiName ? /*#__PURE__*/_jsx(DetailedTermSelector, {
      apiName: suiteApiName,
      onChange: setQueryParamTerm,
      activeTerm: queryParamTerm,
      trackingSource: trackingSourceString
    }) : null
  });
  const Credits = /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [17],
    widths: ['75%'],
    children: !!includedProductLevelHubspotCredits && /*#__PURE__*/_jsx(IncludedHubSpotCredits, {
      includedProductLevelHubspotCredits: includedProductLevelHubspotCredits,
      trackingSource: TRACKING_SOURCE
    })
  });
  const Features = /*#__PURE__*/_jsx(SuiteFeatures, {
    productLevel: productLevel,
    loading: !isAppReady,
    isCollapsible: isMobile
  });
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `${suiteApiName}-merch-card`,
    "data-selenium-id": `${suiteApiName}-merch-card`,
    columnStart: columnStart,
    Badge: Badge,
    Title: /*#__PURE__*/_jsx(SuiteCardTitle, {
      productLevel: productLevel,
      showProductLevelTitle: screen !== 'crm'
    }),
    Subheading: SubHeading || null,
    Pricing: !!suiteSkuId && /*#__PURE__*/_jsx(PriceDisplayContainer, {
      skuId: suiteSkuId,
      queryParamTerm: queryParamTerm,
      apiName: suiteApiName
    }),
    Seats: Seats,
    Term: TermSelector,
    Credits: Credits,
    CTAs: /*#__PURE__*/_jsx(SuiteCardCTAs, {
      productLevel: productLevel,
      screen: screen,
      trackingSource: TRACKING_SOURCE
    }),
    Features: Features
  });
};